// ** Icons Import
import {Menu, Circle, EyeOff, Folder, AlignJustify, LifeBuoy, Shield, Users} from 'react-feather'

export default [
  {
    header: 'ADMIN',
    action: 'manage',
    isAdmin: true
  },
  {
    id: 'admin_users',
    action: 'manage',
    title: 'menu_admin_users',
    icon: <Users size={12} />,
    navLink: '/admin/users'
  },
  {
    id: 'adminReportFeed',
    action: 'manage',
    title: 'menu_admin_reportFeed',
    icon: <Folder size={12} />,
    navLink: '/admin/reportFeed'
  },
  {
    id: 'admin-banners',
    action: 'manage',
    title: 'menu_admin_banners',
    icon: <Folder size={12} />,
    navLink: '/admin/banners'
  },
  {
    id: 'admin-tournaments',
    action: 'manage',
    title: 'menu_admin_tournaments',
    icon: <Folder size={12} />,
    navLink: '/admin/tournaments'
  },
  {
    id: 'admin-ranks',
    action: 'manage',
    title: 'menu_admin_ranks',
    icon: <Folder size={12} />,
    navLink: '/admin/ranks'
  },
  {
    id: 'admin-approve-custom-bets-settlement',
    action: 'manage',
    title: 'menu_admin_approveCustomBetsSettlement',
    icon: <Folder size={12} />,
    navLink: '/admin/approveCustomBetsSettlement'
  }
]
